// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file requests/v1/analytics_order_request.proto (package requests.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import { file_buf_validate_validate } from '../../buf/validate/validate_pb';
import type { Timestamp } from '@bufbuild/protobuf/wkt';
import { file_google_protobuf_timestamp } from '@bufbuild/protobuf/wkt';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file requests/v1/analytics_order_request.proto.
 */
export const file_requests_v1_analytics_order_request: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CilyZXF1ZXN0cy92MS9hbmFseXRpY3Nfb3JkZXJfcmVxdWVzdC5wcm90bxILcmVxdWVzdHMudjEiSQoVQW5hbHl0aWNzT3JkZXJSZXF1ZXN0EjAKBGZyb20YASABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wQga6SAPIAQFCgAEKD2NvbS5yZXF1ZXN0cy52MUIaQW5hbHl0aWNzT3JkZXJSZXF1ZXN0UHJvdG9QAVoELi9wYqICA1JYWKoCC1JlcXVlc3RzLlYxygILUmVxdWVzdHNcVjHiAhdSZXF1ZXN0c1xWMVxHUEJNZXRhZGF0YeoCDFJlcXVlc3RzOjpWMWIGcHJvdG8z',
        [file_buf_validate_validate, file_google_protobuf_timestamp]
    );

/**
 * @generated from message requests.v1.AnalyticsOrderRequest
 */
export type AnalyticsOrderRequest = Message<'requests.v1.AnalyticsOrderRequest'> & {
    /**
     * @generated from field: google.protobuf.Timestamp from = 1;
     */
    from?: Timestamp | undefined;
};

/**
 * Describes the message requests.v1.AnalyticsOrderRequest.
 * Use `create(AnalyticsOrderRequestSchema)` to create a new message.
 */
export const AnalyticsOrderRequestSchema: GenMessage<AnalyticsOrderRequest> =
    /*@__PURE__*/
    messageDesc(file_requests_v1_analytics_order_request, 0);
